import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin, Cpu } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Cpu className="h-6 w-6 text-blue-500" />
              <h3 className="text-xl font-bold bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text">
                JK SemiTech
              </h3>
            </div>
            <p className="text-gray-400">
              Leading manufacturer of drone technology and semiconductor solutions, driving innovation in industrial automation.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Solutions</h3>
            <ul className="space-y-2">
              <li><Link to="/services#drones" className="text-gray-400 hover:text-white transition-colors">Drone Manufacturing</Link></li>
              <li><Link to="/services#semiconductor" className="text-gray-400 hover:text-white transition-colors">Semiconductor Solutions</Link></li>
              <li><Link to="/services#automation" className="text-gray-400 hover:text-white transition-colors">Industrial Automation</Link></li>
              <li><Link to="/courses" className="text-gray-400 hover:text-white transition-colors">Training Programs</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Info</h3>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-400">
                <Phone className="h-5 w-5 mr-2" />
                <span>+91 7092639169</span>
              </li>
              <li className="flex items-center text-gray-400">
                <Mail className="h-5 w-5 mr-2" />
                <span>jksemitech@gmail.com</span>
              </li>
              <li className="flex items-center text-gray-400">
                <MapPin className="h-5 w-5 mr-2" />
                <span>Kolathur, Chennai</span>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Connect With Us</h3>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Instagram className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} JK SemiTech. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;